import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { AccountManager } from '@atlas/core';
import { Icon, Label, MoneyInput } from '@atlas/ui';

const LimitInput = ({ field, onChange, required, ...props }) => {
  const { error, errorMessage, formRef, name, value, warning, ...fieldProps } = field;
  const currency = AccountManager.getAccountCurrency();

  const handleBlur = useCallback(() => {
    formRef.current.blurField(name);
  }, [formRef, name]);

  const handleChange = useCallback(
    newValue => {
      onChange(newValue, true);
      if (formRef.current) {
        // Immediately set the field as touched
        formRef.current.touchedFields[name] = true;
      }
    },
    [name, formRef, onChange],
  );

  return (
    <div className="limit__input">
      {required ? (
        <div className="limit__input__required">
          <Label className="limit__input-label" message={`responsible_game_${name}_limit`} />{' '}
          <span className="limit__input__mark">*</span>
        </div>
      ) : (
        <Label className="limit__input-label" message={`responsible_game_${name}_limit`} />
      )}

      {warning && (
        <span className="limit__warning-block">
          <Icon name="warning" />
          <Label {...warning} />
        </span>
      )}
      <MoneyInput
        currency={currency}
        label="Amount"
        onBlur={handleBlur}
        onChange={handleChange}
        value={value}
        {...fieldProps}
        {...props}
      />
      {error && (
        <div className="limit__error-block">
          <Icon height={24} name="icon-error" width={24} />
          <div>
            <Label className="limit__error-text-title" message="not_saved_limit_title" />
            <Label className="limit__error-text-message" message={errorMessage} />
          </div>
        </div>
      )}
    </div>
  );
};

LimitInput.propTypes = {
  field: PropTypes.shape({
    errorMessage: PropTypes.string.isRequired,
    formRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({
        current: PropTypes.instanceOf(HTMLInputElement),
      }),
    ]),
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    warning: PropTypes.arrayOf([PropTypes.string]),
  }).isRequired,
};

export default LimitInput;
